"use client";
import { InstantSearchNext } from "react-instantsearch-nextjs";
import { blogSearchClient } from "@/components/Blog/BlogSearch/client";
import {
  BLOG_SEARCH_INDEX_NAME,
  searchStateMapping,
} from "@/components/Blog/BlogSearch/utils";

export default function BlogSearchWrapper({ children }) {
  return (
    <InstantSearchNext
      indexName={BLOG_SEARCH_INDEX_NAME}
      searchClient={blogSearchClient}
      routing={{
        stateMapping: searchStateMapping,
      }}
      future={{ preserveSharedStateOnUnmount: true }}
    >
      {children}
    </InstantSearchNext>
  );
}
